/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Input } from '@angular/core';
import { I18nService, TimeService } from '@dm/core';
import { eventType, infigo } from '@dm/live-material-infigo';

import { GlobalSearchService } from '../../../global-search.service';
import { isChinese } from '../../conditionalSearch/asserts';
import { DEFAULT_VALUE } from '../../const';

interface Items {
    title: string;
    key: string;
    enumMap?: { [key: string]: string };
    templateName?: string;
    templateParams: { [key: string]: any };
    isLongString?: boolean;
}

@Component({
    selector: 'app-base-info-list',
    templateUrl: './base-info-list.component.html',
    styleUrls: ['./base-info-list.component.scss'],
})
export class BaseInfoListComponent {
    @Input() items: Items[];
    @Input() data: any;
    @Input() loading = false;
    DEFAULT_VALUE = DEFAULT_VALUE;

    constructor(public time: TimeService, public global: GlobalSearchService, public i18n: I18nService) {
    }

    isEmpty(value: { [x: string]: string }): boolean {
        return typeof value === 'object' && Object.keys(value).every((i) => value[i] !== 'TRUE');
    }

    getValue(data: { [x: string]: any }, key: string | number | any[]): any {
        if (typeof key === 'string') {
            return data[key];
        }
        if (Array.isArray(key)) {
            const realKey = key.find((k) => Boolean(data[k]));
            return data[realKey];
        }

        return undefined;
    }

    formatTime = (value: number): string => this.time.formatOffsetUTC(value * 1e3);

    clickListItem(link, data): void {
        if (link) {
            infigo.dispatch(eventType.CLICK_LIST_ITEM, typeof link === 'function' ? link(data) : link);
        }
    }

    getEnumMapValue(value: string | number, enumMap: { [x: string]: any }): any {
        if (!value) {
            return DEFAULT_VALUE;
        }
        return enumMap ? enumMap[value] || DEFAULT_VALUE : value;
    }

    getMinWidth(): string {
        if (!Array.isArray(this.items)) {
            return '0px';
        }
        let max = 0;
        this.items.forEach((i) => {
            const length = this.getWidth(i.title) * 14;
            if (length > max) {
                max = length;
            }
        });
        return `${max + 10}px`;
    }

    getWidth(str: string): number {
        let length = 0;
        for (const charStr of str) {
            if (/(\d|[A-Za-z])/.test(charStr)) {
                length += 0.5;
            } else if (this.i18n.language === 'ja') {
                length += 0.7;
            } else if (isChinese(str)) {
                length += 1;
            } else {
                length += 0.3;
            }
        }
        return length + 1.5;
    }
}
